import { render } from "./PurchaseQuality.vue?vue&type=template&id=6c63ca07&scoped=true"
import script from "./PurchaseQuality.vue?vue&type=script&lang=js"
export * from "./PurchaseQuality.vue?vue&type=script&lang=js"

import "./PurchaseQuality.vue?vue&type=style&index=0&id=6c63ca07&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c63ca07"]])

export default __exports__